import React, { useState } from "react";
import { Nav, Button, Image } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import sidelogo from "../../../assets/img/Ai-powered-cv-logo.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SideBar.css";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  return (
    <>
      {/* Mobile Menu Button */}
      {isMobile && (
        <Button
          onClick={() => setOpen(!open)}
          className="btn btn-primary position-fixed"
          style={{ top: "10px", left: "10px", zIndex: 1300 }}
        >
          ☰
        </Button>
      )}

      {/* Sidebar */}
      <div
        className={`sidebar bg-light ${open ? "d-block" : "d-none d-md-flex"}`}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "250px",
          height: "100%",
          padding: "20px 15px",
          boxShadow: "2px 0 10px rgba(0, 0, 0, 0.1)",
          zIndex: 1300,
          transition: "all 0.3s ease-in-out",
        }}
      >
        {/* Close Button for Mobile */}
        {isMobile && (
          <Button
            onClick={() => setOpen(false)}
            className="btn btn-danger position-absolute"
            style={{
              top: "10px",
              right: "10px",
              zIndex: 1400,
              fontSize: "18px",
              fontWeight: "bold",
              borderRadius: "50%",
            }}
          >
            ×
          </Button>
        )}

        <Nav className="flex-column w-100 text-center">
          <Image src={sidelogo} alt="Logo" fluid style={{ margin: "0 auto" , width: "150px", height: "auto" }} 
            onClick={() => navigate("/")}/>
          <hr />




          {/* Templates Section */}
          <Nav.Item
            onClick={() => navigate("/dashboard/templatelist")}
            className={`nav-link py-2 ${location.pathname.startsWith("/dashboard/templatelist") ? "active" : ""}`}
            style={{
              cursor: "pointer",
              borderRadius: "8px",
              backgroundColor: location.pathname.startsWith("/dashboard/templatelist") ? "purple" : "transparent",
              color: location.pathname.startsWith("/dashboard/templatelist") ? "white" : "black",
              fontWeight: "bold",
            }}
          >
            Templates
          </Nav.Item>

          <Nav.Item
            onClick={() => navigate("/dashboard/draft")}
            className={`nav-link py-2 ${location.pathname === "/dashboard/draft" ? "active" : ""}`}
            style={{
              cursor: "pointer",
              borderRadius: "8px",
              backgroundColor: location.pathname === "/dashboard/draft" ? "purple" : "transparent",
              color: location.pathname === "/dashboard/draft" ? "white" : "black",
              fontWeight: "bold",
            }}
          >
            Draft
          </Nav.Item>

          <Nav.Item
            onClick={() => navigate("/dashboard/resumescorer")}
            className={`nav-link py-2 ${location.pathname === "/dashboard/resumescorer" ? "active" : ""}`}
            style={{
              cursor: "pointer",
              borderRadius: "8px",
              backgroundColor: location.pathname === "/dashboard/resumescorer" ? "purple" : "transparent",
              color: location.pathname === "/dashboard/resumescorer" ? "white" : "black",
              fontWeight: "bold",
            }}
          >
            Resumescorer
          </Nav.Item>

        </Nav>
      </div>
    </>
  );
};

export default Sidebar;
